// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { useCallback, useState } from 'react';
import { FeedbackPopup } from './FeedbackDialog';
import { LightBorderButton, headerLightButtonStyles } from '../LightBorderButton';

export const FeedbackButton = (props: { callId?: string }): JSX.Element => {
  const [popupOpen, setPopupOpen] = useState(false);
  const openPopup = useCallback(() => {
    setPopupOpen(true);
  }, []);
  const closePopup = useCallback(() => {
    setPopupOpen(false);
  }, []);
  const [feedbackDialogKey, setFeedbackDialogKey] = useState<string>(`FeedbackDialog ${Math.random()}`);
  const resetFeedbackDialog = useCallback(() => {
    // Updating key ensures a new feedback form is created (resetting all fields in the feedback form)
    setFeedbackDialogKey(`FeedbackDialog ${Math.random()}`);
  }, [setFeedbackDialogKey]);

  return (
    <>
      <LightBorderButton
        onClick={openPopup}
        styles={headerLightButtonStyles}
        text="Give Feedback"
        iconProps={{ iconName: 'PersonFeedback' }}
      />
      {
        <FeedbackPopup
          key={feedbackDialogKey}
          isOpen={popupOpen}
          onDismiss={closePopup}
          resetFields={resetFeedbackDialog}
          callId={props.callId}
        />
      }
    </>
  );
};
